// Page Components
import PageType from '../components/Page/Page';
import LoaderType from '../components/Page/Loader';

// Page Variants
export const pageTypes = {
  'Page': PageType,
  'Loader': LoaderType,
};